import { api } from "../common/utils"
import {
  INVOICE_DIAGNOSTIC_ENDPOINT,
  LODESTAR_DIAGNOSTIC_ENDPOINT
} from "../common/constants"

// Invoice Diagnostic types

export interface InvoiceCheck {
  check: string
  passed: boolean
  diagnosis: string
}

export interface InvoiceSingleResult {
  org_id: number
  org_name: string
  month: number
  year: number
  checks: InvoiceCheck[]
  summary: {
    total: number
    passed: number
    failed: number
  }
}

export interface InvoiceBulkOrgProblem {
  org_id: number
  org_name: string
  issues: string[]
}

export interface InvoiceBulkResult {
  month: number
  year: number
  total_orgs: number
  problems: InvoiceBulkOrgProblem[]
  [key: string]: any
}

export interface InvoiceSingleParams {
  org_id: number
  month: number
  year: number
}

export interface InvoiceBulkParams {
  month: number
  year: number
  include_zero?: boolean
  exclude_has_stripe_invoice?: boolean
}

export interface LodestarParams {
  mode: "inventory" | "lookup"
  state?: string
  zipcode?: string
  loan_amount?: number
  loan_purpose?: string
  list_price?: number
  refresh?: boolean
}

const diagnosticsApi = {
  invoiceSingle: async (
    params: InvoiceSingleParams
  ): Promise<InvoiceSingleResult> => {
    const { data } = await api.get(INVOICE_DIAGNOSTIC_ENDPOINT, { params })
    return data
  },

  invoiceBulk: async (
    params: InvoiceBulkParams
  ): Promise<InvoiceBulkResult> => {
    const { data } = await api.get(INVOICE_DIAGNOSTIC_ENDPOINT, { params })
    return data
  },

  lodestar: async (params: LodestarParams): Promise<string> => {
    const { data } = await api.get(LODESTAR_DIAGNOSTIC_ENDPOINT, { params })
    if (data?.output) return data.output
    return typeof data === "string" ? data : JSON.stringify(data, null, 2)
  }
}

export default diagnosticsApi
